import React, { useCallback, useEffect, useState } from 'react'
import { faAngleRight, faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './Accordion.css'

interface IAccordionProps {
  header: string | React.ReactNode
  renderHeader?: (isOpen: boolean, toggleOpen: (event: any) => void) => any
  openByDefault?: boolean
  isOpen?: boolean
  onToggle?: (newState: boolean) => void
  className?: string
  style?: React.CSSProperties
}

const Accordion: React.FC<IAccordionProps> = ({
  isOpen: isOpenProp,
  header,
  renderHeader,
  openByDefault,
  onToggle,
  className,
  style,
  children,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(!!openByDefault)

  useEffect(() => {
    if (isOpenProp === false) {
      setIsOpen(false)
    } else if (isOpenProp) {
      setIsOpen(true)
    } else {
      setIsOpen(!!openByDefault)
    }
  }, [isOpenProp, openByDefault])

  const toggleOpen = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault()
      if (onToggle) {
        onToggle(!isOpen)
      }
      setIsOpen(!isOpen)
    },
    [isOpen, onToggle]
  )

  return (
    <div className={className} style={style}>
      {renderHeader ? (
        renderHeader(isOpen, toggleOpen)
      ) : (
        <a href='/#' onClick={toggleOpen} className='accordion-link'>
          <div>{header} </div>
          {isOpen ? (
            <FontAwesomeIcon icon={faAngleDown} />
          ) : (
            <FontAwesomeIcon icon={faAngleRight} />
          )}
        </a>
      )}
      <div style={{ display: isOpen ? 'block' : 'none' }}>{isOpen && children}</div>
    </div>
  )
}
export default Accordion
